// extracted by mini-css-extract-plugin
export default {"card":"ZY-z"};